export const PATCH_VOICE_ASSISTANT = '@@myDevices/patchVoiceAssistant'

export const PATCH_VOICE_ASSISTANT_PIN = '@@myDevices/patchVoiceAssistantPin'
